module.exports = __webpack_public_path__ + "img/technologyImg4.07d02824.png";